import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PreferencesService {

  private URL: string = environment.rootUrl;

  constructor(
    private http: HttpClient
  ) { }

  public getPreferences(): Promise<any> {
    return this.http.get(`${this.URL}/preferences`).toPromise();
  }

  public createPreferences(preferences: any): Promise<any> {
    return this.http.post(`${this.URL}/preferences`, preferences).toPromise();
  }

  public updatePreferences(preferences: any): Promise<any> {
    return this.http.put(`${this.URL}/preferences`, preferences).toPromise();
  }
}
